import { render, staticRenderFns } from "./DepartmentUserCreatorTable.vue?vue&type=template&id=6d882ffc&scoped=true"
import script from "./DepartmentUserCreatorTable.vue?vue&type=script&lang=js"
export * from "./DepartmentUserCreatorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d882ffc",
  null
  
)

export default component.exports